import React from 'react';

export default function ProgressBar({ current, total }) {
  const percent = total > 0 ? ((current / total) * 100).toFixed(2) : '0.00';
  return (
    <div style={{ display: 'flex', alignItems: 'center',marginLeft: 35,marginBottom: 2}}>
      <span style={{ marginRight: 10, color: '#666', fontSize: 14}}>
        私信进度: {current}/{total}
      </span>
      <div style={{
        width: 200,
        height: 8,
        background: '#f0f0f0',
        borderRadius: 4,
        marginRight: 8,
        overflow: 'hidden'
      }}>
        <div style={{
          width: `${percent}%`,
          height: '100%',
          background: '#1890ff',
          borderRadius: 4,
          transition: 'width 0.3s ease'
        }}></div>
      </div>
      <span style={{ color: '#666', fontSize: 14 }}>
        {percent}%
      </span>
    </div>
  );
}